import createValues from './createValues';
import plain from './structure/plain';

export default createValues(plain);


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/values.js
// module id = 721
// module chunks = 7